import React from 'react';
import PropTypes from 'prop-types';

export default function DescriptiveText({ isSanityQuestion, getText }) {
  // Only show sanity description when the survey language is the same as
  // the UI language to avoid issues in translation RES-1241
  const shouldShowSanityDescription =
    isSanityQuestion && !Pollfish.helper.hasShownSanityOnce;
  if (!shouldShowSanityDescription) {
    return '';
  }

  Pollfish.helper.hasShownSanityOnce = true;
  return (
    <small className="answers-wrapper--description">
      {getText('sanity_description')}
    </small>
  );
}

DescriptiveText.propTypes = {
  isSanityQuestion: PropTypes.bool,
  getText: PropTypes.func,
};
